module.exports = __webpack_public_path__ + "media/images/leadership-learning-txt-6689316f91e5adce68e008164dec6090.svg";